module.exports = __webpack_public_path__ + "8837c63ad8776fad09bbe9498ec06a31.svg";